import { FilterState, FilterSchema, GLDashboardRow } from "@jem/components";

// eslint-disable-next-line
const toCamelCase = require("lodash/camelCase");

function filterOnSearchCriteria(searchCriteria: string | null, gridItems: GLDashboardRow[]) {
  if (searchCriteria !== null && searchCriteria !== "") {
    const newItems: GLDashboardRow[] = [];
    for (const row of gridItems) {
      for (const [type, value] of Object.entries(row)) {
        // everything is a string, if it is a number then avoid
        if (typeof value === "number" || typeof value === "boolean" || typeof value === "object") {
          continue;
        }

        const colKey = type.toLowerCase();
        if (colKey.indexOf("time") !== -1) {
          const theDate = new Date(value).toLocaleDateString();
          if (theDate && theDate.toLowerCase().indexOf(searchCriteria.toLowerCase()) !== -1) {
            newItems.push(row);
            break;
          }
        } else {
          if (value && value.toLowerCase().indexOf(searchCriteria.toLowerCase()) !== -1) {
            newItems.push(row);
            break;
          }
        }
      }
    }
    return newItems;
  }
  return gridItems;
}

function filterOnCommandBarFilters(
  filtersCriteria: FilterState["filterBar"],
  filters: FilterSchema<GLDashboardRow>[],
  gridItems: GLDashboardRow[]
) {
  let newItems: GLDashboardRow[] = gridItems;
  for (const filterType of filters) {
    const camelCaseFilterName = toCamelCase(filterType.filterName);
    const filterValue = filtersCriteria[`${camelCaseFilterName}Selected` as keyof FilterState["filterBar"]];

    // Skip filters that don't have initialized values yet
    if (filterValue == null || filterValue === undefined) {
      continue; // Skip this filter entirely
    }

    if (!filterValue.length) {
      // user removed all items
      return [];
    } else {
      newItems = newItems.filter((row) => {
        const filterRowName = filterType.columnName;
        if (Array.isArray(row[filterRowName as keyof GLDashboardRow])) {
          const genericArr = row[filterRowName as keyof GLDashboardRow] as unknown[];
          if (genericArr.every((element) => typeof element === "string")) {
            // The array is of type string[]
            const strArr = row[filterRowName as keyof GLDashboardRow] as string[];
            return filterValue.some((item) => strArr.indexOf(item) !== -1);
          } else {
            // The array contains elements of mixed types
            console.error("Array contains mixed types... TODO?");
          }
        } else if (
          (filterType.columnName === "dueDate" || filterType.columnName === "postingDueDate") &&
          row[filterRowName as keyof GLDashboardRow]
        ) {
          const theDate = row[filterRowName as keyof GLDashboardRow] as string;
          return filterValue.indexOf(theDate) !== -1;
        } else {
          const cell = row[filterRowName as keyof GLDashboardRow];
          return filterValue.indexOf(cell as string) !== -1;
        }
      });
    }
  }
  return newItems;
}

export function glFilterRows(
  filterState: FilterState,
  filters: FilterSchema<GLDashboardRow>[],
  gridItems: GLDashboardRow[]
): GLDashboardRow[] {
  let newItems = gridItems;
  newItems = filterOnCommandBarFilters(filterState.filterBar, filters, newItems);
  newItems = filterOnSearchCriteria(filterState.searchCriteria, newItems);
  return newItems;
}
